import React, { createContext, useContext, useState } from 'react';

interface HeaderVisibilityContextProps {
  forceShowHeader: () => void;
}

const HeaderVisibilityContext = createContext<HeaderVisibilityContextProps>({
  forceShowHeader: () => {},
});

export const useHeaderVisibility = () => useContext(HeaderVisibilityContext);

export const HeaderVisibilityProvider = ({ children }) => {
  const [_, setForceShowKey] = useState<number>(0);

  const forceShowHeader = () => {
    // Cambiar la key para forzar que Header lo detecte
    setForceShowKey((prev) => prev + 1);
  };

  return (
    <HeaderVisibilityContext.Provider value={{ forceShowHeader }}>
      {children}
    </HeaderVisibilityContext.Provider>
  );
};
